import styles from './Cases.module.css';
import pic1 from '../../assets/images/pic1.png';
import pic2 from '../../assets/images/pic2.png';
import pic3 from '../../assets/images/pic3.png';

const Cases = () => {
  return (
    <section className={styles.cases}>
      <h2 className={styles.title}>Кейсы</h2>
      <div className={styles.caseBlock}>
        <div className={styles.imageContainer}>
          <img src={pic1} alt="Кейс 1" className={styles.image} />
        </div>
        <div className={styles.textPlaceholder}>
          <p>
            Для российского завода мы организовали закупку
            и мультимодальную доставку станков из Германии
            в условиях санкций. Срок поставки — один месяц
            с полным таможенным оформлением <br/>
            и сертификацией.
          </p>
        </div>
      </div>
      <div className={`${styles.caseBlock} ${styles.reverse}`}>
        <div className={styles.imageContainer}>
          <img src={pic2} alt="Кейс 2" className={styles.image} />
        </div>
        <div className={styles.textPlaceholder}>
          <p>
            По техническому заданию клиента нашли
            производителя в Китае, оформили контракт
            и доставили партию санкционных микросхем
            транзитом через ОАЭ. Сформировали полный
            пакет сопроводительных документов.
          </p>
        </div>
      </div>
      <div className={styles.caseBlock}>
        <div className={styles.imageContainer}>
          <img src={pic3} alt="Кейс 3" className={styles.image} />
        </div>
        <div className={styles.textPlaceholder}>
          <p>
            Оперативно закупили и доставили в Россию
            реагенты для лаборатории, оформив все
            разрешения на опасный груз. Поставка «от двери
            до двери» заняла менее трех недель.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Cases;
